import React, { FC } from "react";
import cx from "classnames";
import { IInboxRowProps, InboxRow } from "component-library";
import "./styles.scss";

const SelfTapesInboxRow: FC<
  React.PropsWithChildren<
    Pick<
      IInboxRowProps,
      | "sender"
      | "isChecked"
      | "value"
      | "title"
      | "additionalInfo"
      | "isRead"
      | "onClick"
      | "onSelect"
      | "tags"
      | "labels"
    > & { isAccepted?: boolean }
  >
> = ({
  sender,
  isChecked,
  value,
  title,
  additionalInfo,
  isRead,
  onClick,
  onSelect,
  tags,
  labels,
  isAccepted,
}) => {
  return (
    <InboxRow
      sender={sender}
      isChecked={isChecked}
      value={value}
      title={title}
      additionalInfo={additionalInfo}
      isRead={isRead}
      onClick={onClick}
      onSelect={onSelect}
      tags={tags}
      labels={labels}
      className={cx("self-tapes-request-inbox-row-flagged", {
        "self-tapes-request-inbox-row-flagged--accepted": isAccepted,
      })}
    />
  );
};

export default SelfTapesInboxRow;
